import React, { useRef, useState } from "react";
import { RecordRTCPromisesHandler } from "recordrtc";

const Videojs = () => {
  const [data, setData] = useState(null);
  const [showStream, setShowStream] = useState(false);
  const [showRecordedStream, setShowRecordedStream] = useState(false);
  const [stream, setStream] = useState(null);
  const [recorder, setRecorder] = useState(null);
  let vref = useRef();
  let [video_local, setVi] = useState("");
  const handleStart = async () => {
    setShowStream(true);
    const stream = await navigator.mediaDevices.getUserMedia({
      video: true,
      audio: true,
    });
    if (stream) {
      vref.current.srcObject = stream;
    }
    const rec = new RecordRTCPromisesHandler(stream, {
      type: "video",
      mimeType: "video/webm",
    });
    await rec.startRecording();

    setRecorder(rec);
    setStream(stream);
    // setVideoUrlBlob(null)
    // preview.srcObject = stream;
  };
  async function onStop() {
    setShowStream(false);
    setShowRecordedStream(true);
    stream.getTracks().forEach((track) => track.stop());
    if (recorder) {
      await recorder.stopRecording();
      const d = await recorder.getBlob();
      setData(d);
      setRecorder(null);
      setStream(null);
    }
  }
  return (
    <div>
      {showStream && (
        <video ref={vref} muted autoPlay width="300" height="240" />
      )}
      {!!data && showRecordedStream && (
        <video
          src={window.URL.createObjectURL(data)}
          id="preview2"
          autoPlay
          controls
          width="300"
          height="240"
        />
      )}
      <br />
      <button onClick={handleStart}>Start</button>
      {/* <button onClick={startRecording}>Start Recording</button> */}
      <button onClick={onStop}>Stop</button>
    </div>
  );
};

export default Videojs;
